export interface IClientDataResponse {
  createdAt?: string;
  updatedAt?: string;
  defaultClientIntent?: string;
  id: string;
  name: string;
  sprucePowered: boolean;
}

export type IClientData = IClientDataResponse;

export const convertIClientDataResponseToIClientData = (data: IClientDataResponse): IClientData => data;

export const convertIClientDataToIClientDataResponse = (data: IClientData): IClientDataResponse => data;

export const createDefaultClientInformation = (): IClientDataResponse => ({
  id: '',
  name: '',
  sprucePowered: false,
});

export interface IClientCompanyData {
  createdAt?: string;
  updatedAt?: string;
  defaultClientIntent?: string;
  id: string;
  name: string;
  sprucePowered: boolean;
  isActive: boolean;
}
